// removed by extract-text-webpack-plugin
module.exports = {"main_right_content":"components-tjcx-xsjfxxcx-scjtXsjfxxcx-index-main_right_content-2UFxe","table":"components-tjcx-xsjfxxcx-scjtXsjfxxcx-index-table-KYY0U"};


//////////////////
// WEBPACK FOOTER
// ./components/tjcx/xsjfxxcx/scjtXsjfxxcx/index.css
// module id = 567
// module chunks = 0